import { IFormItem } from '@components/Form/FormItem/FormItem';
import { Validators } from '@components/Form/FormItem/FormItemValidation';

import { CANCEL_REASON, cancelReasonMap } from '@/shared/vaccination/enums';

export const addDisease = () =>
  [
    {
      label: 'Название заболевания',
      key: 'diseaseDescription',
      type: 'text',
      placeholder: 'Введите название заболевания',
      validation: [Validators.required()],
      payload: {
        maxLength: 250,
      },
    },
  ] as IFormItem[];

export const addDescription = () =>
  [
    {
      label: 'Другая причина',
      key: 'cancelDescription',
      type: 'text',
      placeholder: 'Введите иную причину',
      validation: [Validators.required()],
      payload: {
        maxLength: 250,
        default: cancelReasonMap[CANCEL_REASON.LACK_OF_VACCINE],
      },
    },
  ] as IFormItem[];
